import React, { useState } from 'react';
import useDetectionLabelHook from '../hooks/useDetectionLabelHook'; // Use default import
import Button from '../../../../../components/Atoms/Button.jsx';
import TrainingConfigModal from '../../components/TrainingConfigModal';

const DetectionFilter = () => {
  const {
    handlers
  } = useDetectionLabelHook();
  const [isTrainingModalOpen, setTrainingModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const TRAINING_CONFIG_STORAGE_KEY = 'lf-detection-training-config';

  const fallbackConfig = {
    modelVariant: 'yolov8n.pt',
    epochs: 5,
    imgsz: 640,
    stratify: true,
    trainSplit: 70,
    valSplit: 20,
    testSplit: 10,
    batchSize: 16,
    enableEarlyStopping: true,
    patience: 50,
  };

  const loadStoredTrainingConfig = () => {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return fallbackConfig;
    }
    try {
      const raw = window.sessionStorage.getItem(TRAINING_CONFIG_STORAGE_KEY);
      if (!raw) return fallbackConfig;
      const parsed = JSON.parse(raw);
      return {
        ...fallbackConfig,
        ...parsed,
      };
    } catch (error) {
      console.warn('Unable to load stored detection training config', error);
      return fallbackConfig;
    }
  };

  const [defaultConfig, setDefaultConfig] = useState(loadStoredTrainingConfig);

  const persistTrainingConfig = (config) => {
    setDefaultConfig(config);
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    try {
      window.sessionStorage.setItem(TRAINING_CONFIG_STORAGE_KEY, JSON.stringify(config));
    } catch (error) {
      console.warn('Unable to persist detection training config', error);
    }
  };

  const trainingAdvancedOptions = {
    enableStratify: true,
    enableSplitControls: true,
    enableBatchSize: true,
    enableEarlyStopping: true,
    batchSizeOptions: [1,2,4,8, 16],
    minTrainPercent: 50,
    splitLabels: { train: 'Train', val: 'Validation', test: 'Test' },
  };

  const modelOptions = [
    'yolov8n.pt',
    'yolo11n.pt',
  ];

  const handleTrainingSubmit = async (config) => {
    try {
      setIsSubmitting(true);
      const result = await handlers.handleStartDetectionTraining(config);
      if (result !== false) {
        persistTrainingConfig(config);
        setTrainingModalOpen(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="page-header-title">
        <h5 className="m-b-10">Detection labeling</h5>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Button type="button"
            className='btn btn-secondary btn-sm'
            onClick={handlers.handleSaveDetectionData}
            tooltipText={"Save"}>
            Temp Save
          </Button>
          <Button type="button"
            className='btn btn-primary btn-sm'
            onClick={handlers.handleDownloadDetectionData}
            tooltipText={"Export formatted data"}>
            Export
          </Button>
          <Button type="button"
            className='btn btn-primary btn-sm'
            onClick={() => setTrainingModalOpen(true)}
            tooltipText={"Training AI Model"}>
            Training
          </Button>
        </div>
      </div>
      <TrainingConfigModal
        title="Detection Training Configuration"
        isOpen={isTrainingModalOpen}
        defaults={defaultConfig}
        modelOptions={modelOptions}
        onSubmit={handleTrainingSubmit}
        onClose={() => setTrainingModalOpen(false)}
        submitting={isSubmitting}
        advancedOptions={trainingAdvancedOptions}
      />
    </>
  );
};

export default DetectionFilter;
